/* istanbul ignore file */

import { LoginController } from "./login.js";
import { SendCodeController } from "./sendCode.js";
import { SignUpController } from "./signUp.js";
import { ResetPasswordController } from "./resetPassword.js";
import { VerifyCodeController } from "./verifyCode.js";
import { SignUpCredentialsController } from "./signUpCredentials.js";
import { CompleteController } from "./complete.js";
import { NewPasswordController } from "./newPassword.js";
import { LogoutController } from "./logout.js";
import { NotAuthorizedController } from "./notAuthorized.js";

export const Controllers = {
	LoginController,
	SignUpController,
	SignUpCredentialsController,
	SendCodeController,
	VerifyCodeController,
	ResetPasswordController,
	NewPasswordController,
	CompleteController,
	LogoutController,
	NotAuthorizedController
};
